var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrashBoldIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0001 3H18.0001V2.5C18.0001 1.83696 17.7367 1.20107 17.2678 0.732233C16.799 0.263392 16.1631 0 15.5001 0L8.50006 0C7.83702 0 7.20114 0.263392 6.73229 0.732233C6.26345 1.20107 6.00006 1.83696 6.00006 2.5V3H1.00006V6H3.00006V21C3.00006 21.7956 3.31613 22.5587 3.87874 23.1213C4.44135 23.6839 5.20441 24 6.00006 24H18.0001C18.7957 24 19.5588 23.6839 20.1214 23.1213C20.684 22.5587 21.0001 21.7956 21.0001 21V6H23.0001V3ZM18.0001 21H6.00006V6H18.0001V21Z",
    fill: "#F18221"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 9H7.99991V18H10.9999V9Z",
    fill: "#F18221"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 9H13.0001V18H16.0001V9Z",
    fill: "#F18221"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBoldIcon);
export default __webpack_public_path__ + "static/media/trash-bold-icon.6dc7a8e8a4ec1e18a53082edc26a3efd.svg";
export { ForwardRef as ReactComponent };